import React from 'react'

import { Field } from 'formik'

import { Form, Col, Button } from '_zari/core'

import * as EstructuraBalanceService from 'services/estructuraBalance.service'

const CorrelativoFormGroup = ({ iError, iTouched, fIsSubmitting, setFieldValue, values, handleChange }) => {
  const clickGenerarCodigo = React.useCallback(() => {
    EstructuraBalanceService.nuevoCorrelativo({ idNodoSeleccionado: values.idNodoSeleccionado }).then(({ data }) => {
      setFieldValue('correlativo', data)
      setFieldValue('generarCorrelativoFlag', true)
    })
  }, [setFieldValue, values])
  return (
    <Form.Group>
      <Form.Label text='CORRELATIVO' htmlFor='input-correlativo' md={4} />
      <Col md={8}>
        <Form.InputGroup>
          <Field name='correlativo'>
            {({ field }) => (
              <Form.InputText
                {...field}
                isInvalid={iTouched && iError}
                id='correlativo'
                name='correlativo'
                onChange={e => {
                  handleChange(e)
                  setFieldValue('correlativo', e.target.value)
                  setFieldValue('generarCorrelativoFlag', false)
                }}
              />
            )}
          </Field>
          <Form.InputGroup.Append>
            <Button color='secondary' onClick={clickGenerarCodigo}>
              Generar
            </Button>
          </Form.InputGroup.Append>
        </Form.InputGroup>
      </Col>
    </Form.Group>
  )
}

export default React.memo(CorrelativoFormGroup)
